const padWithLeadingZeros = (num) => {
    if (num === undefined) {
        return '00'
    }
    return String(num).padStart(2, '0')
}
export default padWithLeadingZeros